(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nul-gallery-scroll-animation"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function clamp(v, a, b) {
      return Math.max(a, Math.min(b, v));
    }

    function initGalleryScrollAnimation(root) {
      if (!root || root.dataset.gsaInitialized === 'true') return;
      root.dataset.gsaInitialized = 'true';

      var large = root.querySelector('[data-gsa-large]');
      var left = root.querySelector('[data-gsa-left]');
      var right = root.querySelector('[data-gsa-right]');
      if (!large) return;

      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
      if (reduce.matches) return;

      var mobileQuery = window.matchMedia('(max-width: 768px)');
      var ticking = false;

      function update() {
        ticking = false;
        var rect = root.getBoundingClientRect();
        var vh = window.innerHeight || document.documentElement.clientHeight;
        var scrollable = rect.height - vh;
        if (scrollable <= 0) return;
        var p = clamp(-rect.top / scrollable, 0, 1);

        var isMobile = mobileQuery.matches;
        var startW = isMobile ? 56 : 36;
        var endW = 100;
        var startH = isMobile ? 60 : 84;
        var endH = 100;
        large.style.width = startW + (endW - startW) * p + 'vw';
        large.style.height = startH + (endH - startH) * p + 'vh';

        var fade = clamp(1 - (p - 0.6) / 0.4, 0, 1);
        if (left) left.style.opacity = fade;
        if (right) right.style.opacity = fade;
      }

      function onScroll() {
        if (!ticking) {
          ticking = true;
          window.requestAnimationFrame(update);
        }
      }

      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            window.addEventListener('scroll', onScroll, { passive: true });
            window.addEventListener('resize', onScroll, { passive: true });
            update();
          } else {
            window.removeEventListener('scroll', onScroll);
            window.removeEventListener('resize', onScroll);
          }
        });
      }, { threshold: 0 });

      io.observe(root);
      update();
    }

    function initAll(scope) {
      var roots = (scope || document).querySelectorAll('[data-gsa-root]');
      roots.forEach(initGalleryScrollAnimation);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAll();
      });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nul-locations"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var ACCORDION_MS = 400;

    function prefersReducedMotion() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    function loadImage(img) {
      if (!img || !img.dataset.src) return;
      img.src = img.dataset.src;
      if (img.dataset.srcset) img.srcset = img.dataset.srcset;
      img.removeAttribute('data-src');
      img.removeAttribute('data-srcset');
    }

    function prefetchImages(root) {
      root.querySelectorAll('.nul-locations__image[data-src]').forEach(loadImage);
    }

    function watchPrefetch(root) {
      if (!('IntersectionObserver' in window)) {
        prefetchImages(root);
        return;
      }

      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            prefetchImages(root);
            io.disconnect();
          });
        },
        { rootMargin: '200px 0px' }
      );

      io.observe(root);
    }

    function imageIsReady(img) {
      return Boolean(img && img.complete && img.naturalWidth > 0);
    }

    function showImage(root, index) {
      root.querySelectorAll('.nul-locations__image-wrap').forEach(function (wrap) {
        wrap.classList.toggle('is-active', wrap.dataset.index === String(index));
      });
    }

    function setAddressHeight(address, expand) {
      if (!address) return;

      if (prefersReducedMotion()) {
        address.style.height = expand ? 'auto' : '0px';
        if (expand) address.setAttribute('data-expanded', 'true');
        else address.removeAttribute('data-expanded');
        return;
      }

      if (expand) {
        address.removeAttribute('data-expanded');
        address.style.height = 'auto';
        var height = address.scrollHeight;
        address.style.height = '0px';
        address.offsetHeight;
        address.style.height = height + 'px';
        window.setTimeout(function () {
          address.style.height = 'auto';
          address.setAttribute('data-expanded', 'true');
        }, ACCORDION_MS);
      } else {
        address.removeAttribute('data-expanded');
        var current = address.scrollHeight;
        address.style.height = current + 'px';
        address.offsetHeight;
        address.style.height = '0px';
      }
    }

    function activate(root, index) {
      var items = root.querySelectorAll('.nul-locations__item');

      items.forEach(function (item) {
        var on = item.dataset.index === String(index);
        item.classList.toggle('is-active', on);

        var trigger = item.querySelector('.nul-locations__trigger');
        if (trigger) {
          trigger.setAttribute('aria-selected', on ? 'true' : 'false');
          trigger.setAttribute('aria-expanded', on ? 'true' : 'false');
        }

        setAddressHeight(item.querySelector('.nul-locations__address'), on);
      });

      var target = root.querySelector('.nul-locations__image-wrap[data-index="' + index + '"]');
      var img = target && target.querySelector('.nul-locations__image');

      if (!img) {
        showImage(root, index);
        return;
      }

      loadImage(img);

      // Keep the current image visible until the next one is ready (avoids empty flash).
      if (imageIsReady(img)) {
        showImage(root, index);
        return;
      }

      var onReady = function () {
        img.removeEventListener('load', onReady);
        img.removeEventListener('error', onReady);
        showImage(root, index);
      };

      img.addEventListener('load', onReady);
      img.addEventListener('error', onReady);
    }

    function initLocations(root) {
      if (!root || root.dataset.nulLocationsInitialized === 'true') return;
      root.dataset.nulLocationsInitialized = 'true';

      root.querySelectorAll('.nul-locations__item').forEach(function (item) {
        var trigger = item.querySelector('.nul-locations__trigger');
        if (!trigger) return;
        trigger.addEventListener('click', function () {
          if (item.classList.contains('is-active')) return;
          activate(root, item.dataset.index);
        });
      });

      var firstAddress = root.querySelector('.nul-locations__item.is-active .nul-locations__address');
      if (firstAddress) {
        firstAddress.style.height = 'auto';
        firstAddress.setAttribute('data-expanded', 'true');
      }

      watchPrefetch(root);
    }

    function initAll(scope) {
      var roots = (scope || document).querySelectorAll('[data-nul-locations]');
      roots.forEach(initLocations);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAll();
      });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recommendations"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const row = document.querySelector('.product-single__related.product-row');
    const leftArrow = document.getElementById('scrollLeft');
    const rightArrow = document.getElementById('scrollRight');

    // Function to determine breakpoints
    const getSlideItemCount = () => {
      const width = window.innerWidth;
      if (width <= 768) {
        // mobile devices
        return 1;
      } else if (width <= 1024) {
        // tablets
        return 3;
      } else {
        return 4; // Desktop
      }
    };

    // Function to calculate the scroll amount based on breakpoints
    const getScrollAmount = () => {
      const itemWidth = row.querySelector('.product-card-wrapper').offsetWidth;
      return getSlideItemCount() * itemWidth;
    };

    // Function to disable arrows when scrolled to the max
    function updateArrowVisibility() {
      const isFullyScrolledLeft = row.scrollLeft === 0;
      const isFullyScrolledRight = Math.ceil(row.scrollWidth - row.offsetWidth) === Math.ceil(row.scrollLeft);

      leftArrow.disabled = isFullyScrolledLeft;
      rightArrow.disabled = isFullyScrolledRight;

      const isAllVisible = row.scrollWidth <= row.offsetWidth;
      leftArrow.style.display = isAllVisible ? 'none' : 'inline-flex';
      rightArrow.style.display = isAllVisible ? 'none' : 'inline-flex';
    }

    leftArrow.addEventListener('click', () => {
      row.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
    });

    rightArrow.addEventListener('click', () => {
      row.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
    });

    row.addEventListener('scrollend', updateArrowVisibility);
    window.addEventListener('resize', updateArrowVisibility);

    updateArrowVisibility(); // Initial check
  });

  } catch(e) { console.error(e); }
})();
})();
